import { __awaiter, __generator } from "tslib";
import { getOfficeRouteParamsFromDriveItem } from '@office-start/office-route-utility';
import { OfficeRouteItemType, } from '@office-start/officehome-types';
import { getLaunchInstrumentationParamsFromKnownArea } from './getLaunchInstrumentationParamsFromKnownArea';
import { launchUrl } from './launchUrl';
export function launchDraftContent(document, area) {
    return __awaiter(this, void 0, void 0, function () {
        var canonicalUrl, docId, driveId, sharepointIds, route, officeRouteParams, param;
        return __generator(this, function (_a) {
            canonicalUrl = document.canonicalUrl, docId = document.docId, driveId = document.driveId, sharepointIds = document.sharepointIds;
            if (!driveId || !docId || !canonicalUrl) {
                return [2 /*return*/, { success: false }];
            }
            route = {
                route: 'MyContent',
                type: OfficeRouteItemType.Base,
                entityId: 'drafts',
                subEntityId: 'content',
            };
            officeRouteParams = getOfficeRouteParamsFromDriveItem(driveId, docId, canonicalUrl, (sharepointIds === null || sharepointIds === void 0 ? void 0 : sharepointIds.siteUrl) ? { siteUrl: sharepointIds.siteUrl } : {});
            param = getLaunchInstrumentationParamsFromKnownArea(area, undefined, 'Draft');
            return [2 /*return*/, launchUrl(route, { action: 'OpenInBrowser' }, param, officeRouteParams)];
        });
    });
}
//# sourceMappingURL=launchDraftContent.js.map